import { render, staticRenderFns } from "./CreatedUsersList.vue?vue&type=template&id=6e7467d6&"
import script from "./CreatedUsersList.vue?vue&type=script&lang=js&"
export * from "./CreatedUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports